// extracted by mini-css-extract-plugin
export default {"titleWrapper":"TitleWrapper_titleWrapper__Ey6KI","left":"TitleWrapper_left__jH8g5","right":"TitleWrapper_right__0ezB-","center":"TitleWrapper_center__oUdzg"};